import { graphql } from 'gql'

export const AUTH_USER_CURRENT_WORKSPACE_FRAGMENT = graphql(`
  fragment AuthUserCurrentWorkspaceFragment on Workspace {
    active
    alerts {
      description
      name
    }
    id
    latestGamConnectionOrder @include(if: $canAccessGamConnection) {
      status
    }
    name
    networkCode
    pipedriveLink
    prebidManagerSampling
    priceGeniusAlwaysOn
    primaryCurrency
  }
`)

export const AUTH_USER_FRAGMENT = graphql(`
  fragment AuthUserFragment on User {
    currentWorkspace {
      ...AuthUserCurrentWorkspaceFragment
    }
    currentWorkspaceRole
    email
    features {
      enabled
      name
    }
    firstName
    id
    lastName
    role
    workspaceProducts {
      product
      status
    }
    workspaces {
      alerts {
        description
        name
      }
      id
      name
      networkCode
    }
  }
`)
